"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankAccountCreationType = exports.BankAccountStatus = void 0;
var BankAccountStatus;
(function (BankAccountStatus) {
    BankAccountStatus["PENDING"] = "pending";
    BankAccountStatus["VERIFIED"] = "verified";
    BankAccountStatus["DISABLED"] = "disabled";
    BankAccountStatus["MANUAL_CHECK"] = "manual check required";
})(BankAccountStatus = exports.BankAccountStatus || (exports.BankAccountStatus = {}));
var BankAccountCreationType;
(function (BankAccountCreationType) {
    /** The bank account was created via Open Banking Data API */
    BankAccountCreationType["DATA_API"] = "data_api";
    /** The bank account was pulled automatically from an external source (accounting integration, etc) */
    BankAccountCreationType["EXTERNAL"] = "external";
    /** The bank account was manually created via the frontend/api */
    BankAccountCreationType["MANUAL"] = "manual";
})(BankAccountCreationType = exports.BankAccountCreationType || (exports.BankAccountCreationType = {}));
